import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { formatCurrency as formatCurrencyUtil } from '../lib/currency';

/**
 * Hook to load and use currency settings from the database
 * Returns currency code, symbol, and a format function
 */
export function useCurrency() {
  const [currency, setCurrency] = useState<string>('BDT');
  const [currencySymbol, setCurrencySymbol] = useState<string>('৳');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCurrencySettings();
  }, []);

  const loadCurrencySettings = async () => {
    try {
      const { data, error } = await supabase
        .from('app_settings')
        .select('key, value')
        .in('key', ['currency_code', 'currency_symbol']);

      if (error) throw error;

      const currencyCode = data?.find(s => s.key === 'currency_code')?.value || 'BDT';
      const symbol = data?.find(s => s.key === 'currency_symbol')?.value || '৳';

      setCurrency(currencyCode);
      setCurrencySymbol(symbol);
    } catch (error) {
      console.error('Error loading currency settings:', error);
      setCurrency('BDT');
      setCurrencySymbol('৳');
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount: number): string => {
    return formatCurrencyUtil(amount, currency, currencySymbol);
  };

  return {
    currency,
    currencySymbol,
    formatCurrency,
    loading,
  };
}
